// import Vue from 'vue'

/**
 * Created by jiachenpan on 16/11/18.
 */
export const getQueryString = function (e) {
  var t = new RegExp('(^|&)' + e + '=([^&]*)(&|$)')
  var search = window.location.search
  var a = search.substr(1).match(t)
  if (a != null) return a[2]
  return ''
}

export function delParam (paramKey) {
  var url = window.location.href // 页面url
  var urlParam = window.location.search.substr(1) // 页面参数
  if (url.indexOf('?') === -1) {
    return url
  }
  var beforeUrl = url.substr(0, url.indexOf('?')) // 页面主地址（参数之前地址）
  var nextUrl = ''

  var arr = []
  if (urlParam !== '') {
    var urlParamArr = urlParam.split('&') // 将参数按照&符分成数组
    for (var i = 0; i < urlParamArr.length; i++) {
      var paramArr = urlParamArr[i].split('=') // 将参数键，值拆开
      // 如果键雨要删除的不一致，则加入到参数中
      if (paramArr[0] !== paramKey) {
        arr.push(urlParamArr[i])
      }
    }
  }
  if (arr.length > 0) {
    nextUrl = '?' + arr.join('&')
  }
  url = beforeUrl + nextUrl
  return url
}
export function parseTime (time, cFormat) {
  if (!time) {
    return time
  }
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return timeStr
}

export function formatTime (time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

export function isExternal (path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

// 递归解析json
export function resolveJson (json, key, sign, jsonKeys) {
  if (json instanceof Object) {
    if (key === '' || key === undefined) {
      key = 'main'
    }
    for (const p in json) {
      var k = key + sign + p
      if (!(json[p] instanceof Object)) {
        jsonKeys.push(p) // 如果不是Object则打印键值
      } else if (json[p] instanceof Array) {
        resolveJson(json[p][0], k, sign, jsonKeys) // 如果是数组则递归一个
      } else {
        resolveJson(json[p], k, sign, jsonKeys)// 如果是Object则递归
      }
    }
  } else {
    parent.layer.msg('请检查json格式', { icon: 5 })
  }
  return jsonKeys
}

// 防抖动
export function debounce (fn, delay) {
  let timer = null
  return function () {
    const arg = arguments

    clearTimeout(timer)

    timer = setTimeout(() => {
      fn.apply(this, arg)
    }, delay)
  }
}

export const getCurDate = () => {
  const myDate = new Date()
  const year = myDate.getFullYear()
  const month = myDate.getMonth() + 1
  const date = myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate()
  return '' + year + month + date
}
